import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getHome, portalModalSelector, getShared } from 'Store/selectors';
import * as transactionActionLayer from 'Route/Transactions/modules/TransactionsActions';
import { goPopup } from 'Store/actions/portalModalActions';
import { nullSafe } from 'Utility/globalMethods';
import * as actionLayer from '../../modules/HomeActions';
import * as actionShared from 'Store/actions/shared';
import TransactionsPopup from './TransactionsPopup';

const commonParts = (data) => ({
	dateFrom: data.dateFrom !== undefined ? data.dateFrom : null,
	groupId: data.group !== undefined ? data.group : null,
	paymentMethod: ["CARDS"],
	paymentChannel: ["PAYMENT"],
	transactionStatus: data.status !== undefined ? [data.status] : [],
});

const mapDispatchToProps = (dispatch) => ({
	goPopup: (popup) => dispatch(goPopup(popup)),
	fetchTransactionFind: (payload) => dispatch(actionShared.fetchTransactionFind.request({...commonParts(payload), size: 10, pageNumber: 1})),
	doSetItemToShowDetail: (payload) => dispatch(transactionActionLayer.doSetItemToShowDetail({...commonParts(payload), size: 10, pageNumber: 1})),
	...bindActionCreators(actionLayer, dispatch),
});

const mapStateToProps = (state) => ({
	payload: nullSafe(() => portalModalSelector(state).data, {}),
	transactionsLoading: nullSafe(() => getHome(state, 'transactionsPopup').loading, false),
	transactionsData: nullSafe(() => getShared(state, 'transactionsData'), []),
});

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps) => ({
	...stateProps,
	actions: dispatchProps,
}))(TransactionsPopup);
